import React from 'react'
import { Dropdown } from 'dcl-ui'
import classnames from 'classnames'
import { preventDefault } from 'lib/preventDefault'
import { Props } from './OptionsDropdown.types'
import styles from './OptionsDropdown.module.css'

const OptionsDropdown = (props: Props) => {
  const { options, className } = props
  const classes = [styles.OptionsDropdown]
  if (className) {
    classes.push(className)
  }

  return (
    <Dropdown className={classnames(styles.OptionsDropdown, className)} direction="left" onClick={preventDefault()}>
      <Dropdown.Menu>
        {options.map((option, index) => (
          <Dropdown.Item key={index} text={option.text} onClick={option.handler} />
        ))}
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default React.memo(OptionsDropdown)
